import React from 'react';

import {
    Button
} from 'react-bootstrap';

class MoreUserButton extends React.PureComponent {

    state = {
        
    };

    componentDidMount() {
        
    }

    goToGenerateReportHandler = () => {
        this.props.history.push( '/reports/'+ this.props.object.id );
    }
    
    render () {
        return (
            <React.Fragment>
                <Button variant="success pull-right" onClick={this.goToGenerateReportHandler}>
                    <i className="fa fa-table"></i>
                    <span className="hidden-xs hidden-sm">Report Generation</span>
                </Button>
            </React.Fragment>
        )
    }
}

export default MoreUserButton;